export const GET_DATA_USERS  = 'GET_DATA_USERS';
export const SET_DATA_USERS  = 'SET_DATA_USERS';
export const ERROR_DATA_USERS  = 'ERROR_DATA_USERS';
export const SET_LOGIN  = 'SET_LOGIN';
export const SET_DRAWER  = 'SET_DRAWER';
export const GET_DATA_CARTS  = 'GET_DATA_CARTS';

export const ADD_DATA_CARTS  = 'ADD_DATA_CARTS';
export const DEL_DATA_CARTS  = 'DEL_DATA_CARTS';
export const SET_DATA_CARTS  = 'SET_DATA_CARTS';
export const DEL_ALL_DATA_CARTS  = 'DEL_ALL_DATA_CARTS';